import { useQuery } from "@tanstack/react-query";
import { SystemIndexSetsTypes } from "@graylog/server-api";
import { defaultOnError } from "util/conditional/onError";
const INITIAL_DATA = [];
const fetchAllIndexSetIds = async (streams) => SystemIndexSetsTypes.indexSetsWithFieldTypeChangeSupport((streams == null ? void 0 : streams.length) ? streams : void 0).then((elements) => {
  const list = elements.map((element) => ({
    id: element.index_set_id,
    type: element.type
  }));
  return list;
});
const useAllIndexSetIds = (streams) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["allIndexSetIds", ...streams],
    queryFn: () => defaultOnError(
      fetchAllIndexSetIds(streams),
      "Loading index sets with field type change support failed with status",
      "Could not load index sets with field type change support"
    )
  });
  return {
    data: data != null ? data : INITIAL_DATA,
    isLoading,
    refetch
  };
};
export default useAllIndexSetIds;
